import React from 'react';
import { Reveal } from './Reveal';

const LOGOS = [
  { name: 'NorthSignal', glyph: '▲', stack: 'monospace' },
  { name: 'RampUp',     glyph: '◆', stack: 'sans' },
  { name: 'Hexaflow',   glyph: '⬢', stack: 'sans' },
  { name: 'Quantix Labs', glyph: '❖', stack: 'mono' },
  { name: 'PinnacleOps', glyph: '○', stack: 'sans' },
  { name: 'Voltlake',    glyph: '⚡', stack: 'sans' },
  { name: 'Foundry42',   glyph: '■', stack: 'mono' },
  { name: 'KernelPath',  glyph: '⦿', stack: 'mono' },
];

export const LogoCloud = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-2 pb-12">
      <Reveal>
        <div className="flex flex-col items-center text-center">
          <span className="text-[10px] uppercase tracking-[0.22em] text-white/40">
            Operators piloting RevCore today
          </span>
          <div className="mt-5 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-6 lg:gap-10 items-center justify-items-center w-full">
            {LOGOS.map((l) => (
              <div
                key={l.name}
                className="flex items-center gap-2 text-white/55 hover:text-white transition-colors group"
                title={l.name}
              >
                <span
                  className="display text-2xl"
                  style={{ color: '#FFB17A' }}
                  aria-hidden
                >
                  {l.glyph}
                </span>
                <span className={`text-sm tracking-tight ${l.stack === 'mono' ? 'mono' : 'display font-medium'}`}>
                  {l.name}
                </span>
              </div>
            ))}
          </div>
          <div className="mt-5 text-[10px] uppercase tracking-widest text-white/30">
            — illustrative early-design partners
          </div>
        </div>
      </Reveal>
    </section>
  );
};
